import axios from 'axios';

const getJSON = function(url) {
    return axios.get(url.replace("+", "%2B"), { crossdomain: true})	// S3 specific escaping, S3 interprets "+" as a space
        .then((response) => {
            return response.data;
        });
}

export default getJSON;
